import { DrawerContainer } from "../../layout/components/DrawerContainer"


export const Home = () => {
 return (
   <div>
      { <DrawerContainer/> }
   </div>
 )
}